import React from "react";
import "./Chat.css";

function ChatCard({id,tasId, customerId, message}) {
  return (
    <div style={{width: '200px',borderRadius: '20px',backgroundColor: '#EDECED'}} className="wrappers">
      <div className="content">
      <div className="main">
          <div className="main_content">
            <div className="messages">
              <div
                className="bot-message"
                id="message1"
              >{message}
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChatCard;
